import React from 'react';
import { LinkedInPollComponent as LinkedInPollComponentType } from '../types';

interface LinkedInPollComponentProps {
  pollComponent: LinkedInPollComponentType;
}

export const LinkedInPollComponent: React.FC<LinkedInPollComponentProps> = ({ pollComponent }) => {
  return (
    <div className="border border-gray-600 rounded-lg p-4 my-3 bg-gray-800/50">
      <div className="mb-3">
        <h3 className="text-white text-base font-semibold mb-2">Poll</h3>
        <p className="text-white text-sm leading-relaxed">{pollComponent.question}</p>
      </div>
      
      <div className="space-y-2">
        {pollComponent.options.map((option, index) => (
          <div
            key={option.urn}
            className="flex items-center p-3 bg-gray-700/50 rounded-lg border border-gray-600 hover:bg-gray-700/70 transition-colors"
          >
            <div className="flex items-center justify-center w-6 h-6 rounded-full border-2 border-gray-400 mr-3 flex-shrink-0">
              <span className="text-gray-400 text-xs font-medium">{String.fromCharCode(65 + index)}</span>
            </div>
            <span className="text-white text-sm flex-1">{option.text}</span>
          </div>
        ))}
      </div>
      
      <div className="mt-3 text-xs text-gray-400 text-center">
        Poll • {pollComponent.options.length} options
      </div>
    </div>
  );
};
